<template>
  <div class="columns is-mobile is-centered is-vcentered is-full-height">
      <div class="column">
          <div class="columns is-mobile is-centered">
              <div class="column is-two-thirds has-text-centered">
                  <img id="logo" :src="`${publicPath}img/logo.png`" alt="eWATER Services">
              </div>
          </div>
          <div class="columns is-mobile is-centered">
              <div class="column is-full has-text-centered">
                  <div class="notification is-danger">
                      {{ text }}
                  </div>
              </div>
          </div>
          <div class="columns is-mobile is-centered">
              <div class="column is-half">
                  <a @click="$router.go(-1)" class="button is-fullwidth is-info">
                      <span class="icon">
                          <i class="fa fa-arrow-left"></i>
                      </span>
                      <span>{{ $t("Back") }}</span>
                  </a>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "Error",
  props: {
    text: String
  }
};
</script>
